import { useMemo } from "react";

import {
  useVolumeData,
  useFeesData,
  useGlpData,
  useTradersData,
  useUsersData,
} from "../dataProvider";

export function useTotalVolume(chainName) {
  const [totalVolumesData] = useVolumeData({ chainName });
  const [totalVolume, totalVolumeDelta] = useMemo(() => {
    if (!totalVolumesData) {
      return [];
    }
    const total =
      totalVolumesData[totalVolumesData.length - 1]?.cumulative ?? 0;
    const delta =
      total - (totalVolumesData[totalVolumesData.length - 2]?.cumulative ?? 0);

    return [total, delta];
  }, [totalVolumesData]);

  return [totalVolume, totalVolumeDelta];
}

export function useTotalFee(chainName) {
  const [totalFeesData] = useFeesData({ chainName });
  const [totalFees, totalFeesDelta] = useMemo(() => {
    if (!totalFeesData) {
      return [];
    }
    const total = totalFeesData[totalFeesData.length - 1]?.cumulative;
    const delta = total - totalFeesData[totalFeesData.length - 2]?.cumulative;
    return [total, delta];
  }, [totalFeesData]);

  return [totalFees, totalFeesDelta];
}

export function useTotalUsers(chainName) {
  const [usersData] = useUsersData({ chainName });
  const [totalUsers, totalUsersDelta] = useMemo(() => {
    if (!usersData) {
      return [null, null];
    }
    const total = usersData[usersData.length - 1]?.uniqueCountCumulative;
    const prevTotal = usersData[usersData.length - 2]?.uniqueCountCumulative;
    const delta = total && prevTotal ? total - prevTotal : null;
    return [total, delta];
  }, [usersData]);

  return [totalUsers, totalUsersDelta];
}

export function useTotalValueLocked(chainName) {
  const [glpData] = useGlpData({ chainName });
  const [totalAum, totalAumDelta] = useMemo(() => {
    if (!glpData) {
      return [];
    }
    const total = glpData[glpData.length - 1]?.aum ?? 0;
    const delta = total - (glpData[glpData.length - 2]?.aum ?? 0);
    return [total, delta];
  }, [glpData]);

  return [totalAum, totalAumDelta];
}

export function useTotalOpenInterest(chainName) {
  const [tradersData] = useTradersData({ chainName });
  const [openInterest, openInterestDelta] = useMemo(() => {
    if (!tradersData) {
      return [];
    }
    const total =
      tradersData.data[tradersData.data.length - 1]?.openInterest ?? 0;
    const delta =
      total -
      (tradersData.data[tradersData.data.length - 2]?.openInterest ?? 0);
    return [total, delta];
  }, [tradersData]);

  return [openInterest, openInterestDelta];
}
